 import {useParams} from "react-router-dom";
import { FichaTecnicaView } from "../components/ficha-tecnica-view";


const decodeRouteParam = (value) => {
    if (!value) return value;
    try {
        return atob(value);
    } catch {
        return value;
    }
};

export const FichaTecnica = ()=>{

    const {cod_producto,cod_usuario} = useParams();

    return (
        <FichaTecnicaView
            cod_producto={decodeRouteParam(cod_producto)}
            cod_usuario={decodeRouteParam(cod_usuario)}
        />
    );

}   